import { BrowserRouter as Router } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import React from "react";
import AppLayout from "./components/AppLayout";
import AppRoutes from "./components/AppRoutes";
import LoadingSpinner from "./components/LoadingSpinner";
import { appTheme } from "./theme/appTheme";
import { useAuth } from "./hooks/useAuth";
import { useImagePreload } from "./hooks/useImagePreload";
import { ResourceGroupsProvider } from "./context/ResourceGroupsContext";
import { ProfileProvider } from "./context/ProfileContext";

import topbarLogo from "./images/logo.png";
import heroLogo from "./images/logo-notext.png";

function App() {
  const { user, loading: authLoading } = useAuth();

  const imagesToPreload = React.useMemo(() => [topbarLogo, heroLogo], []);

  const { loaded: imagesLoaded } = useImagePreload(imagesToPreload);

  if (authLoading || !imagesLoaded) {
    return <LoadingSpinner message="Loading ..." />;
  }

  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <Router>
        <ResourceGroupsProvider>
          <ProfileProvider>
            <AppLayout user={user}>
              <AppRoutes user={user} />
            </AppLayout>
          </ProfileProvider>
        </ResourceGroupsProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
